<template>
	<div id="container">
		<span  v-html="smsTemplate.content" style="margin-right: 0.75rem;font-size:0.75rem;"></span>
		<a-button size="small" @click="sendTheSms">发送短信</a-button>
	</div>
</template>

<script>
	export default{
		props:[
			'smsTemplate',
		],
		data(){
			return{
				
			}
		},
		methods:{
			sendTheSms:function(){
				let  content = this.smsTemplate.content;
				if(content.indexOf('reason')  !=-1){
					let reason = document.getElementById('reason').value;
					let time = document.getElementById('time').value;	
					this.$emit('tranfromValue',[reason,time]);
					this.$emit('sendSms');
				}else if(content.indexOf('cause')  !=-1){
					let cause = document.getElementById('cause').value;	
					let phone = document.getElementById('phone').value;	
					this.$emit('tranfromValue',[cause,phone]);
					this.$emit('sendSms');
				}
				else{
					this.$emit('sendSms');
				}
			}
		},
	}
</script>

<style scoped="scoped">
	#container{
		text-align: left;
		width: 100%;
		padding-left: 1.25rem;
		margin-bottom:0.6rem;
	}
</style>
